import { MijnRoute } from '../mijn-navigatie.model';

export const HUISMAP: MijnRoute = {
    path: 'huismap',
    navigationEvent: 'toHuismap',
    regex: /^\/huismap$/,
    webcomponent: 'mijn-huismap-webcomponent'
};
